import React, { useEffect, useRef } from 'react';
import anime from 'animejs';
import useTypingEffect from './useTypingEffect';
import animationManager from './utils/AnimationManager';

const TypedOutput = ({ text }) => {
  // Faster typing on mobile for better UX
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const typedText = useTypingEffect(text, isMobile ? 10 : 20);
  const lineRef = useRef(null);

  useEffect(() => {
    if (!lineRef.current || !animationManager.shouldAnimate()) return;

    // Slide in animation for each line
    anime({
      targets: lineRef.current,
      translateX: [-20, 0],
      opacity: [0, 1],
      duration: 300,
      easing: 'easeOutCubic'
    });
  }, []);

  return (
    <div ref={lineRef} className="command-output opacity-0">
      {typedText}
    </div>
  );
};

export default TypedOutput;
